var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "filter_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#filter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M9.504 16a.5.5 0 0 1-.358-.144.48.48 0 0 1-.145-.356v-4.73L4.105 4.814a.49.49 0 0 1-.057-.532q.129-.28.453-.281h11q.322 0 .453.281a.49.49 0 0 1-.058.532l-4.895 5.958V15.5q0 .213-.144.356a.48.48 0 0 1-.355.144zm.497-6.375L13.376 5.5H6.605z"
  }))));
};
export default SvgFilter;